import React, { useState, useEffect, useContext } from "react";
import { withStyles } from '@material-ui/core/styles';
import configData from '../../../config/config.json';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Button } from "@material-ui/core";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlane } from "@fortawesome/free-solid-svg-icons";
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from 'react-i18next';

const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(0),
      backgroundColor:'#eee'
    },
}))(MuiDialogContent);
  
const DialogActions = withStyles((theme) => ({
    root: { 
      margin: 0,
      padding: theme.spacing(1),
    },
}))(MuiDialogActions);


const API_ENDPOINT = configData.API_ENDPOINT;

export default function SimpleDialog(props) {

    const { onClose, flights, packageUid, originalFlightInventoryUID, open, packagePricePP} = props;
    const [loadingFlightUID, setLoadingFlightUID] = useState(null); // State to track which button is loading
    const { t } = useTranslation();

    const handleClose = () => {
        onClose();
    };

    const changeFlight = async (e, flightInventoryUID) => {

        setLoadingFlightUID(flightInventoryUID); // Set the loading state for the clicked button

        // Use the flightInventoryID to make an axios call to:
        console.log(`loadFlights`)
        let url = `${API_ENDPOINT}/search/packages/${packageUid}/flight/${flightInventoryUID}`

        await axios.get(
            url,
            {
              headers: {
                'Content-Type': 'application/json'
              },
              withCredentials: true  
            }
          ).then(res=>{

            if (!res.data || res.data=='')  {
                console.error('DID NOT FIND FLIGHT INVENTORY UID')
                return
            }
            console.log(res)
            let redirect_url = window.location.href;  
            console.log(`old url: ${redirect_url}`)
            redirect_url = redirect_url.replace(packageUid, res.data)
            console.log(`new url: ${redirect_url}`)

            window.location.href = redirect_url;
          }).catch(err=>{
            console.log(err)
            alert(t('package.modals.error.title'))
            setLoadingFlightUID(null); // Reset loading state
          });

          //alert(resPackage.data)

    }

    // Search the flights array for a record whose flight?.raw_flight?.inventory_uid == originalFlightInventoryUID and place it as the first item in the array
    const flight = flights.find(flight => flight?.raw_flight?.inventory_uid == originalFlightInventoryUID)
    // add flight as the first item in the flights array (and remove it's other occurance)
    let flightsArray =  flights.filter(flight => flight?.raw_flight?.inventory_uid != originalFlightInventoryUID);
    if (flight)
        flightsArray.unshift(flight);

    return (
            <Dialog className="change-flight-dialog" fullScreen aria-labelledby="simple-dialog-title" open={open} scroll="paper" id="change_flight" onClose={handleClose}>
                <AppBar className="change-flight-appbar">
                        <Toolbar className="change-flight-toolbar" tabIndex={0}>
                            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h5" className="change-flight-title-text">
                                {t('package.modals.changeFlight.title')}
                            </Typography>
                            <Box component="span" m={2}></Box>
                        </Toolbar>
                </AppBar>
                <DialogContent>
                {flights && flights.length > 0 ? (
                    <div className='ugly modalBody'  >
        
                        <Grid container>
                            <Grid item className='text-center' xs={12}>
                                {flightsArray.map((flight,index) => {
                                
                                    let outbound_arrival_time = flight?.raw_flight?.legs[0].arrival.split('T')[1].split('.')[0];
                                    outbound_arrival_time = outbound_arrival_time.split(':')[0]+':'+outbound_arrival_time.split(':')[1];
                                    let outbound_departure_time = flight?.raw_flight?.legs[0].departure.split('T')[1].split('.')[0];
                                    outbound_departure_time = outbound_departure_time.split(':')[0]+':'+outbound_departure_time.split(':')[1];
                                    let inbound_arrival_time = flight?.raw_flight?.legs[1].arrival.split('T')[1].split('.')[0];
                                    inbound_arrival_time = inbound_arrival_time.split(':')[0]+':'+inbound_arrival_time.split(':')[1];
                                    let inbound_departure_time = flight?.raw_flight?.legs[1].departure.split('T')[1].split('.')[0];
                                    inbound_departure_time = inbound_departure_time.split(':')[0]+':'+inbound_departure_time.split(':')[1];
                                    
                                    let outbound_departure_date = flight?.raw_flight?.legs[0].departure.split('T')[0];
                                    // convert to to DD/MM/YYYY format
                                    outbound_departure_date = outbound_departure_date.split('-')[2]+'/'+outbound_departure_date.split('-')[1]+'/'+outbound_departure_date.split('-')[0];

                                    let outbound_arrival_date = flight?.raw_flight?.legs[0].arrival.split('T')[0];
                                    // convert to to DD/MM/YYYY format
                                    outbound_arrival_date = outbound_arrival_date.split('-')[2]+'/'+outbound_arrival_date.split('-')[1]+'/'+outbound_arrival_date.split('-')[0];

                                    let inbound_departure_date = flight?.raw_flight?.legs[1].departure.split('T')[0];
                                    // convert to to DD/MM/YYYY format
                                    inbound_departure_date = inbound_departure_date.split('-')[2]+'/'+inbound_departure_date.split('-')[1]+'/'+inbound_departure_date.split('-')[0];    

                                    let inbound_arrival_date = flight?.raw_flight?.legs[1].arrival.split('T')[0];
                                    // convert to to DD/MM/YYYY format
                                    inbound_arrival_date = inbound_arrival_date.split('-')[2]+'/'+inbound_arrival_date.split('-')[1]+'/'+inbound_arrival_date.split('-')[0];

                                    let outbound_departure_airport_name = '';
                                    let outbound_arrival_airport_name = '';
                                    let inbound_departure_airport_name = '';
                                    let inbound_arrival_airport_name = '';
                                    let priceDeltaPP = flight?.price_pp-packagePricePP;
                                    if (priceDeltaPP > 0)
                                        priceDeltaPP = Math.ceil(priceDeltaPP)
                                    else
                                        priceDeltaPP = Math.floor(priceDeltaPP)
                                    let flightInventoryUID = flight?.raw_flight?.inventory_uid;
                                    let outbound_duration = flight?.raw_flight?.legs[0].duration;
                                    let inbound_duration = flight?.raw_flight?.legs[1].duration;

                                    let goTime = parseInt(outbound_duration) / 60 / 60;
                                    let goSec = goTime - Math.floor(goTime);
                                    goSec = Math.round(goSec * 60);
                                    goTime = t('flight.duration', { hours: Math.floor(goTime), minutes: goSec });
                                
                                    //Get Return Time and Seconds
                                    let returnTime = parseInt(inbound_duration) / 60 / 60;
                                    let returnSec = returnTime - Math.floor(returnTime);
                                    returnSec = Math.round(returnSec * 60);
                                    returnTime = t('flight.duration', { hours: Math.floor(returnTime), minutes: returnSec });

                                    let outbound_from_iata = flight?.raw_flight?.legs[0].from_iata;
                                    let outbound_to_iata = flight?.raw_flight?.legs[0].to_iata;
                                    let inbound_from_iata = flight?.raw_flight?.legs[1].from_iata;
                                    let inbound_to_iata = flight?.raw_flight?.legs[1].to_iata;


                                    let priceChangeCaption = priceDeltaPP>0 ?
                                        `(${t('package.modals.changeFlight.priceIncrease', { price: priceDeltaPP })})`:
                                        `(${t('package.modals.changeFlight.priceSaving', { price: priceDeltaPP*-1 })})`;
                                    if (priceDeltaPP == 0)
                                        priceChangeCaption = t('package.modals.changeFlight.noChange')

                                    const isOriginalFlight = originalFlightInventoryUID == flight?.raw_flight?.inventory_uid;
                                    if (isOriginalFlight)
                                        priceChangeCaption = t('package.modals.changeFlight.included');
                                
                                    let outbound_airline_code = flight?.raw_flight?.legs[0].airline_code;
                                    let inbound_airline_code = flight?.raw_flight?.legs[1].airline_code;
                                    let outbound_airline_name = flight?.raw_flight?.legs[0].airline_name;
                                    let inbound_airline_name = flight?.raw_flight?.legs[1].airline_name;

                                    
                                    /*let outbound_from_iata = flight?.raw_flight?.legs[0].from_iata;
                                    let outbound_to_iata = flight?.raw_flight?.legs[0].to_iata;
                                    let inbound_from_iata = flight?.raw_flight?.legs[1].from_iata;
                                    let inbound_to_iata = flight?.raw_flight?.legs[1].to_iata;*/
                                    
                                    
                                    return  (
                                    <>
                                        {index==0?(<h3 className="flight-section-heading">{t('package.modals.changeFlight.currentFlight')}</h3>):index==1?(<h3 className="flight-section-heading">{t('package.modals.changeFlight.otherFlights')}</h3>):''}
                                        <div className={isOriginalFlight?"card flight-card-original":"card flight-card-alternative"} key={'item'+index} onClick={index==0?handleClose:null}>
                                            
                                            <div className="flight-details-container" title={t('package.modals.changeFlight.directFlights')}>

                                                <div className="route flight-route-outbound"  title={t('package.modals.changeFlight.outboundFlightDetails', { from: outbound_departure_airport_name, date: outbound_departure_date, time: outbound_departure_time, duration: outbound_duration, to: outbound_arrival_airport_name, arrivalDate: outbound_arrival_date, arrivalTime: outbound_arrival_time })}>
                                                    <div className="flight-airline-info">
                                                        <div className="airline"><img className={"airline-logo "+(outbound_airline_code==null?'hide':'')} src={outbound_airline_code!=null?'/images/airlines/32/'+outbound_airline_code+'.png':''} alt={outbound_airline_code} /></div>
                                                        <p className="airline-name">{outbound_airline_name}</p>
                                                    </div>
                                                    <div className="from flight-from-section">
                                                        <div>
                                                            <p className="flight-iata-code">{outbound_from_iata} </p>
                                                            <div className="time flight-time-large">{outbound_departure_time}</div>
                                                            <p className="flight-date-text">{outbound_departure_date}</p>
                                                        </div>
                                                        {/*<p>יום {outbound_departure_dow}` {outbound_departure_time}</p>*/}
                                                    </div>
                                
                                                    <div className="flight-duration-section">
                                                        <div className="flight-duration-full-width">
                                                            <div className="duration flight-duration-inherit"><p className="duration_caption">{goTime}</p>
                                                            <p className="duration_comment flight-direct-comment">{t('flight.directFlightShort')}</p></div>
                                                        </div>
                                                        <div className="flight-plane-icon"><FontAwesomeIcon icon={faPlane} className="plane-icon-rotated" /></div>
                                                    </div>


                                                    <div className="to flight-to-section">
                                                        <p className="flight-iata-code">{outbound_to_iata} </p>
                                                        <div className="time flight-time-large">{outbound_arrival_time}</div>
                                                        <p className="flight-date-text">{outbound_arrival_date}</p>
                                                    </div>
                                                </div>
                                                <div><hr /></div>
                                                <div className="route flight-route-inbound"  title={t('package.modals.changeFlight.inboundFlightDetails', { from: inbound_departure_airport_name, date: inbound_departure_date, time: inbound_departure_time, duration: inbound_duration, to: inbound_arrival_airport_name, arrivalDate: inbound_arrival_date, arrivalTime: inbound_arrival_time })}>
                                                    <div className="flight-airline-info">
                                                        <div className="airline"><img className={"airline-logo "+(inbound_airline_code==null?'hide':'')} src={inbound_airline_code!=null?'/images/airlines/32/'+inbound_airline_code+'.png':''} alt={inbound_airline_code} /></div>
                                                        <p className="airline-name">{inbound_airline_name}</p>
                                                    </div>
                                                    <div className="from flight-from-section">
                                                        <p className="flight-iata-code">{inbound_from_iata} </p>
                                                        <div className="time flight-time-large">{inbound_departure_time}</div>
                                                        <p className="flight-date-text">{inbound_departure_date}</p>
                                                        {/*<p>יום {inbound_departure_dow}` {inbound_departure_time}</p>*/}
                                                    </div>
                                                    
                                                    <div className="flight-duration-section">
                                                        <div className="flight-duration-full-width">
                                                            <div className="duration flight-duration-inherit"><p className="duration_caption">{returnTime}</p>
                                                            <p className="duration_comment flight-direct-comment">{t('flight.directFlightShort')}</p></div>
                                                        </div>
                                                        <div className="flight-plane-icon"><FontAwesomeIcon icon={faPlane} className="plane-icon-rotated" /></div>
                                                    </div>

                                                    <div className="to flight-to-section">
                                                        <p className="flight-iata-code">{inbound_to_iata} </p>
                                                        <div className="time flight-time-large">{inbound_arrival_time}</div>
                                                        <p className="flight-date-text">{inbound_arrival_date}</p>
                                                    </div>
                                                </div>
                                
                                            </div> 

                                            <div className="flight-pricing-row">
                                                <div className={priceDeltaPP<=0?"flight-price-info flight-price-decrease":"flight-price-info flight-price-increase"}>
                                                        <h3 className="flight-price-delta">{isOriginalFlight?
                                                                                                                                                        '':
                                                                                                                                                        priceDeltaPP==0?'':
                                                                                                                                                            priceDeltaPP>0?'$'+priceDeltaPP+'+':'$'+Math.abs(priceDeltaPP)+'-'}</h3>
                                                        <span className="flight-price-caption">{priceChangeCaption}</span></div>

                                                <div className={isOriginalFlight?"hidden":"flight-change-button-container"}>

                                                    <button
                                                        className="flight-change-button"
                                                        onClick={(e) => changeFlight(e, flightInventoryUID)}
                                                        disabled={loadingFlightUID === flightInventoryUID}
                                                    >
                                                        {loadingFlightUID === flightInventoryUID ? (
                                                            <CircularProgress size="1rem" className="button-loading-spinner" />
                                                        ) : (
                                                            t('package.modals.changeFlight.changeButton')
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )})}
                            </Grid>    
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                {flightsArray.length <= 1 ? (<div className="no-other-flights-message"><h3 align="center" className="no-other-flights-heading">
                                    {t('package.modals.changeFlight.noOtherFlights')}</h3></div>) : ''}
                            </Grid>
                        </Grid>
                    </div>
                ):(<p className="loading-spinner-container"><CircularProgress size="2.5rem" className="loading-spinner-primary"></CircularProgress></p>)}
                </DialogContent>
    
            </Dialog>
    );
}
